import ViewReleaseNotes from './ViewReleaseNotes'
import withLayout from 'components/layout'

export default withLayout(ViewReleaseNotes)
